<template>
    <div>

        <el-table :data="qrcodeList" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading"
                  v-show="!showDialog">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="activeQrcodeId" label="ID" width="100">
            </el-table-column>
            <el-table-column prop="activeNo" label="活动名称" width="150">
                <template slot-scope="scope">
                    <span>{{formInline.activeName}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="qrcodeName" label="二维码名称"></el-table-column>
            <el-table-column prop="bindCode" label="bindCode" width="235"></el-table-column>
            <el-table-column prop="qrcodeImageUrl" label="二维码图片" width="120">
                <template slot-scope="scope">
                    <a :href="scope.row.qrcodeImageUrl" target="_blank">查看</a>
                </template>
            </el-table-column>
            <el-table-column prop="qrcodeUrl" label="二维码连接" width="150"></el-table-column>
            <el-table-column label="操作" fixed="right">
                <template slot="header" slot-scope="scope">
                    操作
                    <el-button type="primary" size="mini" v-show="showNew" @click="addQrcode()">新建</el-button>
                </template>
                <template slot-scope="scope">
                    <el-button type="success" size="mini" @click="editQrcode(scope.row)">编辑</el-button>
                    <el-button type="primary" size="mini" @click="handlePic(scope.row)">上传图片</el-button>
                    <el-button type="success" size="mini" @click="handleCoupon(scope.row)">优惠券</el-button>
                    <!--<el-button type="primary" size="mini" @click="handLogo(scope.row)">二维码加logo</el-button>-->
                </template>

            </el-table-column>
        </el-table>
        <div class="pagination-wrap" v-show="!showDialog">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>
        <el-dialog title="二维码加logo" :visible.sync="showUploadDialog">
            <el-form :model="qrcode"  ref="qrcode" label-width="100px" class="demo-ruleForm">
                <el-form-item label="上传logo">
                    <el-upload
                            class="avatar-uploader"
                            :action=uploadUrl
                            :show-file-list="false"
                            :on-success="uploadSuccess"
                            :before-upload="beforeAvatarUpload">
                        <img v-if="qrcode.qrcodeImageUrl" :src="qrcode.qrcodeImageUrl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <span style="color: red" type="success">点击上传后自动合成到二维码中央位置，合成完毕后请扫码确认是否可正常扫出建议logo尺寸140*140以下</span>
            </el-form>
        </el-dialog>

        <el-dialog title="二维码配置" :visible.sync="showDialog">
            <el-form :model="qrcode" :rules="rules"    ref="qrcode" label-width="100px" class="demo-ruleForm">
                <el-form-item label="自增主键" v-show="false">
                    <el-input v-model="qrcode.activeQrcodeId" placeholder="自增主键"></el-input>
                </el-form-item>

                <el-form-item label="sceneStr" v-show="false">
                    <el-input v-model="qrcode.sceneStr" placeholder="sceneStr"></el-input>
                </el-form-item>

                <el-form-item label="qrcodeImageUrl" v-show="false">
                    <el-input v-model="qrcode.qrcodeImageUrl" placeholder="qrcodeImageUrl"></el-input>
                </el-form-item>
                <el-form-item label="url" v-show="false">
                    <el-input v-model="qrcode.url" placeholder="url"></el-input>
                </el-form-item>
                <el-form-item label="bindCode" v-show="false">
                    <el-input v-model="qrcode.bindCode" placeholder="bindCode"></el-input>
                </el-form-item>
                <el-form-item label="二维码名称" prop="qrcodeName">
                    <el-input v-model="qrcode.qrcodeName" placeholder="二维码名称"></el-input>
                </el-form-item>
                <el-form-item label="类别" prop="activeType">
                    <el-select v-model="qrcode.activeType" clearable filterable placeholder="二维码类型" :disabled="!canEdit" change="activeTypeChange">
                        <el-option
                                v-for="item in activeTypeList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="平台"  v-show="qrcode.activeType===1">
                    <el-select v-model="qrcode.platformId" clearable filterable :disabled="!canEdit" placeholder="平台"  >
                        <el-option v-for="item in platformData"
                                   :key="item.platformId"
                                   :label="item.platformName"
                                   :value="item.platformId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="用户标签" v-show="userLableList.length>0">
                    <el-select v-model="qrcode.userId" clearable filterable  placeholder="用户标签" >
                        <el-option v-for="item in userLableList"
                                   :key="item.dictionaryId"
                                   :label="item.dictionaryName"
                                   :value="item.dictionaryId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="qrcodeUrl" v-show="false">
                    <el-input v-model="qrcode.qrcodeUrl" placeholder="qrcodeUrl"></el-input>
                </el-form-item>
                <el-form-item label="关联关键字" prop="keywordId">
                    <el-select v-model="qrcode.keywordId" clearable filterable placeholder="请选择关联关键字">
                        <el-option
                                v-for="item in keywordList"
                                :key="item.id"
                                :label="item.keyword"
                                :value="item.id">
                        </el-option>
                    </el-select>
                    <span style="color: red">用在扫码时推送消息</span>
                    <el-link :href="getLink(1)" target="_blank">
                        <el-button type="primary" size="mini" class="header-btn">去创建关键字</el-button>
                    </el-link>
                </el-form-item>
                <el-form-item label="分享连接" prop="shareMedia">
                    <el-select v-model="qrcode.shareMedia" clearable filterable placeholder="请选择分享连接">
                        <el-option
                                v-for="item in mediaList"
                                :key="item.id"
                                :label="item.shareTitle"
                                :value="item.id">
                        </el-option>
                    </el-select>
                    <el-link :href="getLink(2)" target="_blank">
                        <el-button type="primary" size="mini" class="header-btn">去创建分享连接</el-button>
                    </el-link>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="resetForm('qrcode')">重置</el-button>
                <el-button type="primary" @click="saveQrcodeConfig('qrcode')" class="header-btn">
                    保 存
                </el-button>
            </div>
        </el-dialog>
    </div>

</template>
<script>
    //导入 HTTP请求方法
    import {getQrActiveList,
        getActiveForOption,
        uploadCollageConfigBanner,
        getMediaforOptions,
        getKeywordsOption,
        saveQrcode,
        getActiveParameter,
        getPlatformList,
        getPlatformList2,
        getMediaforListApi,
        getValidDictionaryList,
    megerQrcodeApi} from '../../api/api';
    export default {
        data() {
            return {
                formInline: {
                    activeNo: "",
                    activeName: "",
                    platformId: 1,
                    currentPage: 1,
                    pageSize: 10,
                    recordsTotal: 0
                },
                showDialog: false,
                showUploadDialog: false,
                loading: true,
                showNew:false,
                platformData:[],
                uploadUrl:uploadCollageConfigBanner,
                activeTypeList:[{id:1,name:'参数二维码'},{id:2,name:'普通二维码'}],
                qrcodeTypeList:[{id:1,name:'公司码'},{id:2,name:'商场码'},{id:3,name:'其他'}],
                qrcodeClassList:[{id:1,name:'地推码'},{id:2,name:'其他'}],
                canEdit:true,
                mediaList:[],
                userLableList:[],
                qrcode: {
                    activeQrcodeId: 0,
                    activeType: 2,
                    keywordId: 0,
                    sceneStr: '',
                    qrcodeUrl: '',
                    qrcodeImageUrl: '',
                    qrcodeName: '',
                    createTime:'',
                    bindCode: '',
                    activeNo: '',
                    shareCount: 0,
                    giveShareCount: 0,
                    qrcodeType: 1,
                    shareMedia: '',
                    payType: 2,
                    url: '',
                    qrcodeClass: 2,
                    userId: '',
                    platformId:1
                },
                keywordList: [],//关键字列表
                activeList: [],// 活动列表
                qrcodeList:[],//二维码列表
                rules: {
                    qrcodeName: [
                        {required: true, message: '请输入二维码名称', trigger: 'blur'},
                        {min: 2, max: 40, message: '长度在 2 到 40 个字符之间', trigger: 'blur'}
                    ],
                    shareMedia: [
                        {required: true, message: '请输入二维码名称', trigger: 'blur'}
                    ]
                }
            }
        },
        //挂载时候执行
        mounted(){
            this.formInline.activeNo = this.$route.query.activeNo;
            this.formInline.activeName = this.$route.query.activeName;
            this.qrcode.qrcodeName=this.$route.query.activeName+'二维码';
            this.qrcode.activeNo=this.$route.query.activeNo;
            this.qrcode.activeNo=this.$route.query.activeNo;
            this.showNew=typeof(this.formInline.activeNo) == "undefined"?false:true;
            console.log(this.showNew);
            //初始化首页数据
            this.getQrcodeList();
            this.getMediaList();
            this.getAllPlatformList();
            if(this.$route.query.activeType==29){
                //投放时加载用户标签
                this.getUserLableList();
            }
        },
        methods: {
            getQrcodeList(){
                this.loading = true;
                getQrActiveList(this.formInline).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.formInline.recordsTotal = res.data.value.total;
                        this.qrcodeList= res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            getAllPlatformList() {
                getPlatformList2().then((res) => {
                    this.platformData=res.data;
                })
            },
            getUserLableList(){
                getValidDictionaryList({dictionaryTypeId:210}).then((res) => {
                    //console.log(res.data.value.list);
                    if(res.data.success){
                        this.userLableList = res.data.value.list;
                    }
                });
            },
            getActiveList(){
                getActiveForOption({}).then((res) => {
                    this.activeList = res.data.value;
                })
            },
            getMediaList(){
                //查找所有可用素材列表
                getMediaforListApi({status:1,platformId:''}).then((res) => {
                    this.mediaList = res.data.value;
                })
            },
            getEnableKeyworldList(){
                //关键字
                getKeywordsOption({platformId:1}).then((res) => {
                    this.keywordList = res.data.filter(item => item.type=='text'||item.type=='image'||item.type=='news'||item.type=='miniCard');
                    this.keywordList.push({'id':0,'keyword':'无'});
                });
            },
            activeTypeChange(){
                //二维码类型改变时执行
            },
            returnHistory(){
                window.history.back()
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getQrcodeList();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getQrcodeList();
            },
            addQrcode(){
                this.showDialog=true;
                this.qrcode.activeQrcodeId=0;
                this.qrcode.qrcodeName=this.$route.query.activeName+'二维码';
                this.qrcode.platformId=1;
                this.qrcode.userId='';
                this.getMediaList();
                this.getEnableKeyworldList();
                this.canEdit=true;
            },
            editQrcode(row){
                //this.getMediaList();
                this.getEnableKeyworldList();
                this.getQrcode(row);
                this.showDialog=true;
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            saveQrcodeConfig(formName){
                this.loading = true;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        //保存二维码
                        this.qrcode.shareMedia=String(this.qrcode.shareMedia);
                        saveQrcode(this.qrcode).then((res) => {
                            this.loading = false;
                            this.showDialog = false;
                            if (res.data.status == 200) {
                                this.$message({
                                    message: '保存成功',
                                    type: 'success'
                                });
                                this.getQrcodeList();
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: res.data.message,
                                    type: 'error'
                                });
                            }
                        });
                    } else {
                        return false;
                    }
                });
            },
            handleCoupon(row){
                //设置优惠券
                this.$router.push({path: '/coupon', query: {bindCode: row.bindCode, sourceName: row.qrcodeName,type: '支付后'}})
            },
            getLink(stat){
                let returnUrl = ''
                if(stat=='1'){
                    returnUrl = `${window.location.origin}/#/wechatKeywordList/detail/0?type=text`
                }else if(stat=='2'){
                    returnUrl = `${window.location.origin}/#/sharelist`
                }
                return returnUrl
            },
            getActiveName(activeNo){
                for ( var i = 0; i <this.activeList.length; i++){
                    if(this.activeList[i].activeNo==activeNo){
                        return this.activeList[i].activeName;
                    }
                }
                return '';
            },

            returnHistory(){
                window.history.back()
            },
            handlePic(row){
                let routerL = '/' + this.$route.path.split('/')[1];
                this.$router.push({
                    path: routerL + '/picture/' + row.bindCode,
                    query: {picType: '15', picName: row.proName, picState: 'product'}
                })
            },
            getQrcode(row){
                this.qrcode.activeQrcodeId= row.activeQrcodeId;
                this.qrcode.bindCode=row.bindCode;
                this.qrcode.qrcodeImageUrl=row.qrcodeImageUrl;
                this.qrcode.sceneStr=row.sceneStr;
                this.qrcode.qrcodeUrl=row.qrcodeUrl;
                this.qrcode.bindCode=row.bindCode;
                this.qrcode.keywordId= row.keywordId;
                this.qrcode.qrcodeClass= row.qrcodeClass;
                this.qrcode.shareMedia= row.shareMedia;
                this.qrcode.giveShareCount= row.giveShareCount;
                this.qrcode.shareCount= row.shareCount;
                this.qrcode.qrcodeName= row.qrcodeName;
                this.qrcode.qrcodeType= row.qrcodeType;
                this.qrcode.activeType= row.activeType;
                this.qrcode.platformId=row.platformId;
                this.qrcode.userId=Number(row.userId);
                this.canEdit=false;
                if(Number(row.shareMedia)!=NaN){
                    this.qrcode.shareMedia=Number(row.shareMedia);
                }
            },
            handLogo(row){
                this.getQrcode(row);
                this.showUploadDialog=true;
            },
            //图片上传成功
            uploadSuccess(res) {
                console.log(res);
                this.showUploadDialog=false;
                if (res.success){
                    //this.collageConfigVo.banner=res.value;
                    megerQrcodeApi({logoUrl:res.value,activeQrcodeId:this.qrcode.activeQrcodeId}).then((res) => {
                        this.qrcode.qrcodeImageUrl=res.data.value;
                        this.getQrcodeList();
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                    });

                }
            },
            beforeAvatarUpload(file){
//                const isJPG = file.type === 'image/jpeg';
//                const isLt2M = file.size / 1024 / 1024 < 1;
//                if (!isJPG) {
//                    this.$message.error('上传头像图片只能是 JPG 格式!');
//                }
//                if (!isLt2M) {
//                    this.$message.error('上传头像图片大小不能超过 1MB!');
//                }
//                return isJPG && isLt2M;
                return true;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/active/activeQrMangement.vue